module.exports = __webpack_public_path__ + "static/media/Ellipse_2.29cc8e44.png";